<div class="media-drawer" *ngIf="data">
    <finder-component-header
        *ngIf="data?.headerData"
        [data]="data.headerData"
    ></finder-component-header>
    <div class="media-drawer-container">
        <finder-generic-text *ngIf="data.headerText"
            class="header-text"
            [data]="data.headerText">
        </finder-generic-text>
        <finder-tutorial *ngIf="data.mainMediaTutorial"
            class="main-tutorial"
            [data]="data.mainMediaTutorial">
        </finder-tutorial>
        <div class="collapsed-content" tabindex="-1">
            <!-- captionedMediaGallery component here cannot be hidden by using ngIf, it causes ME issues -->
            <finder-captioned-media-gallery *ngIf="data.captionedMediaGallery"
                class="image-gallery"
                [ngClass]="{'hidden': !isExpanded}"
                [data]="data.captionedMediaGallery">
                    <finder-generic-text *ngIf="isExpanded && data.topGalleryText" tabindex="0"
                        class="top-gallery-text"
                        [data]="data.topGalleryText">
                    </finder-generic-text>
                    <finder-picture *ngIf="isExpanded && data.poster"
                        class="poster"
                        [picture]="data.poster">
                    </finder-picture>
            </finder-captioned-media-gallery>
        </div>
        <finder-reveal-content class="reveal-content"
            (currentState)="revealContent($event)"
            [showMoreText]="data.showMoreText"
            [showLessText]="data.showLessText">
        </finder-reveal-content>
    </div>
</div>
